<template>
  <section class="container-full-5">
    <h2 class="secondary-font mb-6">Répartition</h2>
    <p class="text-grey-600">Gérez la répartition entre vos cartes.</p>
    <div class="clear-both h-60" />
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CarteRepartition'
})
</script>
